import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import Icon from '@/components/UI/icon/Icon';
import styles from './header.module.scss';
export default function Header({
  handleClose,
  backIcon = false
}) {
  return <Box className={styles['calender-mobile-header']} data-sentry-element="Box" data-sentry-component="Header" data-sentry-source-file="Header.tsx">
      <Box className={styles['calendar-icon-container']} onClick={handleClose} data-sentry-element="Box" data-sentry-source-file="Header.tsx">
        <Icon size="medium" type={'secondary'} name={backIcon ? 'arrow-right-1' : 'close'} data-sentry-element="Icon" data-sentry-source-file="Header.tsx"></Icon>
      </Box>
      <Typography className={styles['calender-header']} variant="title_Bold" data-sentry-element="Typography" data-sentry-source-file="Header.tsx">
        انتخاب تاریخ سفر
      </Typography>
    </Box>;
}